import { render, staticRenderFns } from "./PaymentOrder.vue?vue&type=template&id=44aa5f15"
import script from "./PaymentOrder.vue?vue&type=script&lang=js"
export * from "./PaymentOrder.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrder.vue?vue&type=style&index=0&id=44aa5f15&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports